import { render, staticRenderFns } from "./salesRecord.vue?vue&type=template&id=a6c50064&scoped=true"
import script from "./salesRecord.vue?vue&type=script&lang=js"
export * from "./salesRecord.vue?vue&type=script&lang=js"
import style0 from "./salesRecord.vue?vue&type=style&index=0&id=a6c50064&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6c50064",
  null
  
)

export default component.exports